import { Clock, MapPin, MessageCircle } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

function TikTokIcon({ size = 18 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.04-.1z" />
        </svg>
    );
}

import { Reveal } from "./motion";


function InstagramIcon({ size = 18 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.664-4.919-4.919-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.584.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
        </svg>
    );
}

function FacebookIcon({ size = 18 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
        </svg>
    );
}

const OUTLETS = [
    {
        id: "gilingan",
        name: "Outlet Solo Gilingan",
        address: "Jl. Letjen S. Parman No. 80A, Gilingan, Banjarsari, Solo",
        phone: "+62 858-8909-9909",
        whatsapp: "https://wa.me/6285889099909",
        maps: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
            "DigiKlin Jl. Letjen S. Parman No.80A, Gilingan, Banjarsari, Solo"
        )}`,
    },
    {
        id: "ngemplak",
        name: "Outlet Solo Ngemplak",
        address: "Jl. DI Panjaitan No. 42, Gilingan, Banjarsari, Solo",
        phone: "+62 858-8089-9908",
        whatsapp: "https://wa.me/6285880899908",
        maps: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
            "DigiKlin Jl. DI Panjaitan No.42, Gilingan, Banjarsari, Solo"
        )}`,
    },
];

export default function Footer() {
    const year = new Date().getFullYear();

    return (
        <footer className="relative overflow-hidden bg-ink pb-10 pt-20 text-white/60">
            <div className="pointer-events-none absolute -left-24 -top-24 h-[300px] w-[300px] rounded-full bg-brand/10 blur-3xl" />
            <div className="relative mx-auto max-w-7xl px-6">
                <Reveal>
                    <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
                        <div>
                            <span className="inline-flex items-center rounded-2xl bg-white px-4 py-2.5">
                                <img
                                    src="/logo.webp"
                                    alt="DigiKlin — come do laundry with us"
                                    className="h-12 w-auto"
                                />
                            </span>
                            <p className="mt-5 max-w-xs text-sm leading-relaxed">
                                Laundry Kiloan & Satuan Premium dengan layanan
                                antar jemput gratis. Bersih maksimal, tanpa
                                repot.
                            </p>
                            <div className="mt-5 flex items-center gap-2.5">
                                <a
                                    data-testid="footer-tiktok"
                                    href="https://www.tiktok.com/@digiklin"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="DigiKlin di TikTok"
                                    className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white/80 transition-all duration-200 hover:-translate-y-0.5 hover:bg-brand hover:text-white"
                                >
                                    <TikTokIcon size={18} />
                                </a>
                                <a
                                    data-testid="footer-instagram"
                                    href="https://www.instagram.com/digiklin"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="DigiKlin di Instagram"
                                    className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white/80 transition-all duration-200 hover:-translate-y-0.5 hover:bg-brand hover:text-white"
                                >
                                    <InstagramIcon size={18} />
                                </a>
                                <a
                                    data-testid="footer-facebook"
                                    href="https://www.facebook.com/digiklin"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="DigiKlin di Facebook"
                                    className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white/80 transition-all duration-200 hover:-translate-y-0.5 hover:bg-brand hover:text-white"
                                >
                                    <FacebookIcon size={18} />
                                </a>
                            </div>
                        </div>

                        <div>
                            <h4 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-white">
                                Navigasi
                            </h4>
                            <ul className="mt-5 space-y-3 text-sm">
                                {[
                                    { id: "layanan", label: "Layanan" },
                                    { id: "harga", label: "Harga" },
                                    { id: "syarat-ketentuan", label: "Syarat & Ketentuan" },
                                    { id: "member", label: "Member" },
                                    { id: "testimoni", label: "Testimoni" },
                                    { id: "form", label: "Pesan Antar Jemput" },
                                ].map((l) => (
                                    <li key={l.id}>
                                        <button
                                            data-testid={`footer-link-${l.id}`}
                                            onClick={() => scrollToId(l.id)}
                                            className="transition-colors duration-200 hover:text-brand-bright"
                                        >
                                            {l.label}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div>
                            <h4 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-white">
                                Outlet Kami
                            </h4>
                            <ul className="mt-5 space-y-5 text-sm">
                                {OUTLETS.map((o) => (
                                    <li key={o.id} data-testid={`footer-outlet-${o.id}`}>
                                        <a
                                            data-testid={`footer-outlet-link-${o.id}`}
                                            href={o.maps}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="group block rounded-xl transition-colors duration-200 hover:text-brand-bright"
                                        >
                                            <p className="flex items-start gap-2 font-bold text-white/90 transition-colors duration-200 group-hover:text-brand-bright">
                                                <MapPin
                                                    size={15}
                                                    className="mt-0.5 shrink-0 text-brand-bright"
                                                />
                                                {o.name}
                                            </p>
                                            <p className="mt-1 pl-[23px] leading-relaxed">
                                                {o.address}
                                            </p>
                                            <p className="mt-1.5 pl-[23px] text-xs font-bold text-brand-bright/70 transition-all duration-200 group-hover:translate-x-0.5 group-hover:text-brand-bright">
                                                Buka di Google Maps
                                            </p>
                                        </a>
                                        <a
                                            data-testid={`footer-outlet-wa-${o.id}`}
                                            href={o.whatsapp}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="group mt-1.5 inline-flex items-center gap-1.5 pl-[23px] text-xs font-bold text-brand-bright/70 transition-colors duration-200 hover:text-brand-bright"
                                        >
                                            <MessageCircle size={13} className="shrink-0" />
                                            <span className="group-hover:underline">
                                                WhatsApp {o.phone}
                                            </span>
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div>
                            <h4 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-white">
                                Kontak & Jam Operasional
                            </h4>
                            <ul className="mt-5 space-y-3 text-sm">
                                <li>
                                    <a
                                        data-testid="footer-whatsapp"
                                        href="https://wa.me/6285715550050"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="group inline-flex items-center gap-2 transition-colors duration-200 hover:text-brand-bright"
                                    >
                                        <MessageCircle size={16} className="text-brand-bright" />
                                        <span className="group-hover:underline">+62 857-1555-0050</span>
                                    </a>
                                </li>
                                <li
                                    data-testid="footer-hours"
                                    className="flex items-start gap-2"
                                >
                                    <Clock
                                        size={15}
                                        className="mt-0.5 shrink-0 text-brand-bright"
                                    />
                                    <span>
                                        <span className="block font-semibold text-white/90">
                                            Senin – Sabtu · 07.00 – 20.00 WIB
                                        </span>
                                        <span className="block text-white/50">
                                            Minggu libur
                                        </span>
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </Reveal>

                <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 text-xs sm:flex-row">
                    <p data-testid="footer-copyright">
                        © {year} DigiKlin. Semua hak dilindungi.
                    </p>
                    <a
                        data-testid="footer-admin-link"
                        href="/admin"
                        className="text-white/30 transition-colors duration-200 hover:text-brand-bright"
                    >
                        Admin
                    </a>
                </div>
            </div>
        </footer>
    );
}
